













import { Prop, Vue, Component } from 'vue-property-decorator'

interface TabDef {
  title: string;
  component: string;
}

@Component
export default class TabControl extends Vue {
  @Prop() tabs!: TabDef[];

  currentTab = '';

  created () {
    if (this.tabs.length > 0) {
      this.currentTab = this.tabs[0].component
    }
  }
}
